
import Header from "../components/Header";
import { Footer } from "../components/Footer";
import { Link } from "react-router-dom";


export default function SocialMediaPage() {
  const stripedBg = {
    backgroundImage: "repeating-linear-gradient(-45deg, var(--bg-stripe), var(--bg-stripe) 2px, var(--bg-body) 2px, var(--bg-body) 10px)",
    backgroundColor: "var(--bg-body)",
  };

  const gridHeroBg = {
    backgroundImage: "var(--grid-pattern)",
    backgroundSize: "24px 24px",
    backgroundPosition: "center",
  };

  const steps = [
    {
      step: "01",
      title: "Create an account",
      desc: "Quick signup unlocks access to the full course library. Start your journey in seconds with our streamlined onboarding.",
      tag: "Onboarding",
    },
    {
      step: "02",
      title: "Dive into Courses",
      desc: "Choose your level and follow beginner-to-pro tracks. Master everything from viral hooks to deep audience analytics.",
      tag: "Learning",
    },
    {
      step: "03",
      title: "Download Anytime",
      desc: "Access your lessons anywhere, even without a connection. Perfect for learning on the go or in the studio.",
      tag: "Access",
    },
  ];

  return (
    // Added proper mobile top spacing (pt-8 sm:pt-10) to accommodate the floating header
    <div style={stripedBg} className="min-h-screen w-full md:pt-8  md:pb-8 pt-2 pb-4 px-2 sm:py-2 sm:px-2 lg:px-12 flex justify-center font-sans text-[var(--text-900)] overflow-hidden md:px-8">

      <div
        className="w-full  bg-[var(--bg-box)] rounded-[1.5rem] md:rounded-[2.5rem] overflow-hidden border border-[var(--border-200)] flex flex-col relative"
        style={{ boxShadow: "var(--shadow-box)" }}
      >
        <Header />

        <main className="flex-grow">

          {/* --- ULTRA-CREATIVE HERO --- */}
          <section className="pt-28 sm:pt-36 md:pt-40 pb-20 sm:pb-28 md:pb-32 px-4 sm:px-8 md:px-12 flex flex-col items-center text-center relative overflow-hidden">
            <div className="absolute inset-0 z-0 pointer-events-none" style={gridHeroBg}></div>
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[var(--bg-box)] to-[var(--bg-box)] z-0 pointer-events-none h-full top-1/2"></div>
            
            <div className="inline-flex items-center gap-2 bg-[var(--bg-white)] border border-[var(--border-200)] px-4 py-2 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest mb-6 sm:mb-8 z-10 shadow-sm">
              <span className="w-2 h-2 rounded-full bg-[#e1306c] animate-pulse"></span> For Creators & Brands
            </div>
            
            <h1 className="text-5xl sm:text-6xl md:text-8xl lg:text-[7rem] font-extrabold tracking-tighter mb-6 sm:mb-8 leading-[1.0] z-10 max-w-5xl">
              <span className="text-transparent bg-clip-text bg-gradient-to-br from-[#2e3543] to-slate-400">
                Master Social.
              </span> <br/>
              Grow Your Audience.
            </h1>
            
            <p className="text-base sm:text-lg md:text-xl text-[var(--text-500)] max-w-2xl mb-8 sm:mb-12 z-10 leading-relaxed font-medium px-4">
              Crack the algorithms, master short-form video, and build highly engaged communities across TikTok, Instagram, and LinkedIn.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 z-10 mb-8 sm:mb-10 w-full justify-center max-w-xs sm:max-w-none mx-auto">
              <Link
                to="/pricing"
                className="w-full sm:w-auto min-h-12 bg-[#2e3543] text-white px-10 py-4 rounded-2xl font-bold hover:bg-slate-800 transition-all hover:-translate-y-1 text-sm tracking-wide shadow-lg inline-flex items-center justify-center"
              >
                Enroll in Academy
              </Link>
              <Link
                to="/library"
                className="w-full sm:w-auto min-h-12 bg-white border border-[var(--border-200)] text-[#2e3543] px-10 py-4 rounded-2xl font-bold hover:bg-gray-50 transition-all hover:-translate-y-1 text-sm tracking-wide shadow-sm inline-flex items-center justify-center"
              >
                View Curriculum
              </Link>
            </div>

            {/* Floating Pills (Hidden on Mobile, Visible on Desktop) */}
            <div className="absolute top-1/3 left-10 md:left-32 bg-white border border-[var(--border-200)] px-4 py-2 rounded-xl text-xs font-bold text-slate-500 shadow-lg rotate-[-6deg] z-10 hidden lg:flex items-center gap-2">
              <span className="text-lg">🔥</span> Viral Hooks
            </div>
            <div className="absolute top-1/4 right-10 md:right-32 bg-white border border-[var(--border-200)] px-4 py-2 rounded-xl text-xs font-bold text-slate-500 shadow-lg rotate-[4deg] z-10 hidden lg:flex items-center gap-2">
               Algorithm Secrets <span className="text-lg">↗</span>
            </div>
          </section>

          {/* --- ABOUT US SECTION --- */}
          <section className="py-16 sm:py-24 px-4 sm:px-8 md:px-12 max-w-7xl mx-auto border-t border-[var(--border-100)]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 items-center">
              <div className="w-full aspect-square md:aspect-[5/5] bg-[var(--bg-subtle)] rounded-2xl md:rounded-[2.5rem] overflow-hidden border border-[var(--border-200)] relative group shadow-sm">
                <img
                  src="/about-us-banner-720.jpg"
                  srcSet="/about-us-banner-480.jpg 480w, /about-us-banner-720.jpg 720w, /about-us-banner-960.jpg 960w"
                  sizes="(min-width: 1280px) 608px, (min-width: 1024px) calc((100vw - 160px) / 2), calc(100vw - 32px)"
                  width="720"
                  height="720"
                  alt="Content creation studio"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
              </div>
              
              <div className="max-w-lg w-full lg:ml-auto mt-6 lg:mt-0 text-center lg:text-left mx-auto">
                <div className="inline-flex items-center gap-2 bg-[var(--bg-white)] border border-[var(--border-200)] px-4 py-2 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest mb-6 sm:mb-8 z-10">
                  <span className="w-2 h-2 rounded-full bg-[#e1306c] animate-pulse"></span> About us
                </div>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#2e3543] leading-[1.15] tracking-tight mb-6">
                  We help creators and brands break through engagement plateaus.
                </h2>
                <p className="text-slate-500 text-base sm:text-lg leading-relaxed font-medium">
                  Social media isn't just about posting anymore—it's about strategy. Our bite-sized lessons and progressive curriculum make mastering retention graphs feel completely manageable.
                </p>
              </div>
            </div>
          </section>

          {/* --- SOPHISTICATED BLADE SECTION (Toolkit) --- */}
          <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-8 md:px-12 max-w-7xl mx-auto border-t border-[var(--border-100)]">
            
            {/* SECTION HEADER */}
            <div className="max-w-3xl mb-12 sm:mb-16 md:mb-20 text-center md:text-left mx-auto md:mx-0">
              <div className="flex flex-col md:flex-row items-center gap-3 mb-6">
             
                <span className="inline-flex items-center gap-2 bg-[var(--bg-white)] border border-[var(--border-200)] px-4 py-2 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest">
                  <span className="w-2 h-2 rounded-full bg-[#e1306c] animate-pulse"></span> The Toolkit
                </span>
              </div>
              <h2 className="text-4xl sm:text-5xl md:text-7xl font-black text-[#2e3543] tracking-tighter mb-6 sm:mb-8 leading-[0.95]">
                Everything you need <br className="hidden sm:block"/> to <span className="text-slate-300">master social.</span>
              </h2>
              <p className="text-slate-500 text-lg sm:text-xl leading-relaxed font-medium max-w-xl mx-auto md:mx-0">
                Stop guessing what works. We provide the exact content frameworks that drive millions of views and converted followers.
              </p>
            </div>

            {/* BENTO GRID (Responsive Grid Heights) */}
      {/* --- BENTO SECTION (FLEX-WRAP LAYOUT) --- */}
      <div className="flex flex-col md:flex-row flex-wrap gap-4 sm:gap-6">
              
        {/* Card 1: Content Calendars (66% on Desktop, 100% on Tablet/Mobile) */}
        <div className="w-full xl:w-[calc(66.666%-16px)] flex-grow min-h-[280px] md:min-h-[320px] bg-[#2e3543] rounded-2xl md:rounded-[2.5rem] p-8 md:p-12 flex flex-col justify-between group overflow-hidden relative border border-[#2e3543]">
          <div className="absolute top-0 right-0 w-64 h-64 bg-slate-400/10 blur-[80px] -translate-y-1/2 translate-x-1/4"></div>
          
          <div className="z-10 relative max-w-md">
            <div className="w-12 h-12 bg-white/10 backdrop-blur-md rounded-xl flex items-center justify-center text-xl mb-6 border border-white/10 text-white shadow-sm">
              📅
            </div>
            <h3 className="text-2xl sm:text-3xl font-black mb-4 text-white tracking-tight">365-Day <br /> Content Engine</h3>
            <p className="text-slate-400 leading-relaxed text-base sm:text-lg font-medium">
              Access our private library of content ideas, structured specifically for high retention and viral shareability.
            </p>
          </div>

          {/* Abstract UI Element (Hidden on tiny mobile to save space) */}
          <div className="hidden sm:block absolute right-8 bottom-0 w-80 h-48 bg-white/5 rounded-t-3xl border-t border-l border-r border-white/10 p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-700 ease-out">
              <div className="flex gap-2 mb-4">
                <div className="w-3 h-3 rounded-full bg-slate-400/50"></div>
                <div className="w-12 h-2 rounded-full bg-white/10"></div>
              </div>
              <div className="space-y-3">
                <div className="h-4 w-full bg-white/10 rounded-lg"></div>
                <div className="h-4 w-3/4 bg-white/5 rounded-lg"></div>
                <div className="h-10 w-full bg-slate-400/20 rounded-xl mt-4 border border-slate-400/30"></div>
              </div>
          </div>
        </div>

        {/* Card 2: Creator Focus (33% on Desktop, 50% on Tablet, 100% on Mobile) */}
        <div className="w-full md:w-[calc(50%-12px)] xl:w-[calc(33.333%-8px)] flex-grow min-h-[280px] md:min-h-[320px] bg-gray-50 border border-gray-200 rounded-2xl md:rounded-[2.5rem] p-8 md:p-10 flex flex-col justify-between hover:bg-white hover:shadow-2xl hover:shadow-slate-200 transition-all duration-500 group">
          <div>
            <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-6">Audience</div>
            <h3 className="text-xl sm:text-2xl font-black mb-4 text-[#2e3543] leading-tight">Built for <br /> Modern Creators</h3>
            <p className="text-slate-500 leading-relaxed font-medium text-sm sm:text-base">
              Designed for influencers who want to turn followers into loyal customers.
            </p>
          </div>
          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-[#2e3543] rounded-2xl flex items-center justify-center text-white shadow-lg group-hover:scale-110 group-hover:bg-slate-500 transition-all duration-300 mt-6 md:mt-0">
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
          </div>
        </div>

        {/* Card 3: Analytics (50% on Desktop/Tablet, 100% on Mobile) */}
        <div className="w-full md:w-[calc(50%-12px)] flex-grow min-h-[280px] md:min-h-[320px] bg-white border border-gray-200 rounded-2xl md:rounded-[2.5rem] p-8 md:p-10 flex flex-col justify-between hover:border-slate-300 transition-colors relative overflow-hidden group">
          <div className="absolute right-[-20px] top-[-20px] w-40 h-40 bg-gray-50 rounded-full group-hover:scale-150 transition-transform duration-700"></div>
          <div className="z-10 relative">
            <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gray-50 rounded-2xl flex items-center justify-center text-2xl mb-6 border border-gray-200 shadow-sm">📈</div>
            <h3 className="text-xl sm:text-2xl font-black mb-3 text-[#2e3543]">Deep Analytics</h3>
            <p className="text-slate-500 leading-relaxed font-medium text-sm sm:text-base md:text-lg">
              Master the art of reading retention graphs to double your engagement rate.
            </p>
          </div>
        </div>

        {/* Card 4: Video Editing (50% on Desktop, 100% on Tablet/Mobile) */}
        <div className="w-full xl:w-[calc(50%-12px)] flex-grow min-h-[280px] md:min-h-[320px] bg-white border border-gray-200 rounded-2xl md:rounded-[2.5rem] p-8 md:p-10 flex items-center overflow-hidden relative group" style={gridHeroBg}>
          <div className="absolute inset-0 bg-white/80 backdrop-blur-[2px]"></div> 
          <div className="max-w-md z-10 relative flex flex-col items-start">
            <div className="inline-flex items-center gap-2 bg-[#2e3543] text-white px-3 py-1.5 rounded-full text-[9px] sm:text-[10px] font-bold uppercase tracking-widest mb-6">
                Hot Module
            </div>
            <h3 className="text-2xl sm:text-3xl font-black mb-4 text-[#2e3543]">Video Editing Secrets</h3>
            <p className="text-slate-500 leading-relaxed mb-6 sm:mb-8 text-sm sm:text-base font-medium">
              Master the 3-second hook, fast-paced editing, and sound design.
            </p>
            <Link to="/library" className="w-full sm:w-auto">
              <button className="bg-white border border-gray-200 text-[#2e3543] font-black text-[10px] sm:text-xs uppercase tracking-widest flex items-center gap-3 hover:border-slate-400 px-6 sm:px-8 py-3 sm:py-4 rounded-xl sm:rounded-2xl transition-all shadow-sm active:scale-95 w-full sm:w-auto justify-center">
                EXPLORE MODULES <span>→</span>
              </button>
            </Link>
          </div>
        </div>

      </div>
          </section>

          {/* --- THE BLUEPRINT (Perspective Section) --- */}
          <section className="py-16 sm:py-24 md:py-32 px-4 sm:px-8 md:px-12 max-w-7xl mx-auto border-t border-gray-100 overflow-visible">
            
            {/* SECTION HEADER */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-12 mb-16 sm:mb-24 items-end">
              <div className="text-center lg:text-left mx-auto lg:mx-0">
                <div className="flex flex-col lg:flex-row items-center gap-3 mb-6">
                
                  <span className="inline-flex items-center gap-2 bg-[var(--bg-white)] border border-[var(--border-200)] px-4 py-2 rounded-full text-[10px] sm:text-xs font-bold uppercase tracking-widest"><span className="w-2 h-2 rounded-full bg-[#e1306c] animate-pulse"></span> The Blueprint</span>
                </div>
                <h2 className="text-4xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-[#2e3543] tracking-tighter leading-[0.9]">
                  Engineered <br className="hidden sm:block"/> <span className="text-slate-300">to Scale.</span>
                </h2>
              </div>
              <p className="text-slate-500 font-medium text-base sm:text-lg md:text-xl leading-relaxed lg:max-w-md text-center lg:text-left mx-auto lg:mx-0 lg:pb-2">
                A high-performance path designed to turn your creative output into a predictable business asset.
              </p>
            </div>

            {/* PERSPECTIVE CARDS GRID */}
            {/* Switched from md:grid-cols-3 to lg:grid-cols-3 to prevent squeezing on tablets */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 sm:gap-12 lg:gap-8 xl:gap-12">
              {steps.map((item, idx) => {
                // Tailwind responsive margin logic to fix mobile stacking
                const mtClasses = ['mt-0', 'lg:mt-12', 'lg:mt-24'];
                const actionLink = idx === 0 ? "/signup" : idx === 1 ? "/library" : undefined;
                return (
                  <div 
                    key={idx} 
                    className={`relative group pt-12 lg:pt-0 ${mtClasses[idx]}`}
                  >
                    {/* Massive Background Number */}
                    {/* Adjusted -left-6 to left-0 on mobile so it doesn't cause overflow */}
                    <div className="absolute -top-8 left-0 lg:-top-12 lg:-left-6 text-8xl md:text-9xl font-black text-gray-100 transition-all duration-700 group-hover:text-gray-200 group-hover:-translate-y-4 skew-x-[-10deg] select-none z-0">
                      {item.step}
                    </div>

                    {/* The "Blade" Card */}
                    <div className="relative z-10 bg-white border border-gray-200 rounded-2xl md:rounded-[2.5rem] p-8 md:p-10 shadow-sm transition-all duration-500 group-hover:shadow-2xl group-hover:shadow-slate-200 group-hover:-translate-y-2 lg:group-hover:-translate-y-4">
                      {/* Category Tag */}
                      <div className="inline-block px-3 py-1.5 bg-gray-50 rounded-lg text-[9px] font-black tracking-widest text-slate-400 mb-6 sm:mb-8 border border-gray-200 group-hover:bg-[#2e3543] group-hover:text-white group-hover:border-[#2e3543] transition-colors">
                        {item.tag}
                      </div>

                      <h3 className="text-2xl sm:text-3xl font-black text-[#2e3543] mb-4 sm:mb-6 tracking-tight leading-none">
                        {item.title}
                      </h3>

                      <p className="text-slate-500 font-medium leading-relaxed mb-8 sm:mb-10 opacity-90 group-hover:opacity-100 transition-opacity text-sm sm:text-base">
                        {item.desc}
                      </p>

                      {/* Action Circle */}
                      <div className="flex items-center gap-4">
                        {actionLink ? (
                          <Link
                            to={actionLink}
                            aria-label={idx === 0 ? 'Create an account' : 'Dive into courses'}
                            className="w-10 h-10 rounded-full bg-[#2e3543] flex items-center justify-center text-white transition-all group-hover:bg-slate-600 group-hover:scale-110 shadow-sm cursor-pointer"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                          </Link>
                        ) : (
                          <div className="w-10 h-10 rounded-full bg-[#2e3543] flex items-center justify-center text-white transition-all group-hover:bg-slate-600 group-hover:scale-110 shadow-sm">
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                          </div>
                        )}
                        <span className="text-[10px] font-black uppercase tracking-widest text-[#2e3543] group-hover:text-slate-500 transition-colors">
                            Get Started
                        </span>
                      </div>
                    </div>

                    {/* Ghost Shadow Element */}
                    <div className="absolute inset-0 bg-[#2e3543] rounded-[2.5rem] -z-10 translate-x-2 translate-y-2 lg:translate-x-3 lg:translate-y-3 opacity-0 group-hover:opacity-5 transition-all duration-700 hidden sm:block"></div>
                  </div>
                );
              })}
            </div>

          </section>

        </main>
        <Footer />
      </div>
    </div>
  );
}

